(function () {
  function init() {
    document.querySelectorAll('.collection-description-preview__text--clamped').forEach(function (text) {
      var wrapper = text.closest('.collection-description-preview__inner');
      if (!wrapper) return;
      var toggle = wrapper.querySelector('[data-collection-description-toggle]');
      if (!toggle) return;

      // Only show the toggle if the text is actually being clamped —
      // no point showing "Read more" on a description short enough to
      // already fit within the line-clamp.
      if (text.scrollHeight > text.clientHeight + 1) {
        toggle.hidden = false;
      }

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var next = !expanded;

        text.classList.toggle('collection-description-preview__text--expanded', next);
        text.classList.toggle('collection-description-preview__text--clamped', !next);
        toggle.setAttribute('aria-expanded', String(next));

        toggle.querySelector('[data-label-more]').hidden = next;
        toggle.querySelector('[data-label-less]').hidden = !next;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();